import React, { useEffect, useRef, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading';
import ConfigurationHeader from '../../components/heading/ConfigurationHeader';
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getMetaDataConfig, getNewConfiguration, overWriteConfig, postConfiguration, updateConfiguration } from '../../services/uiConfigService';
import { configurationAttributeType, newConfigurationNames } from '../../types';
import { filterLabelType } from '../../types/types';
import Input from "../../components/Input/Input"
import * as yup from 'yup';
import store from '../../stateManagement/store';
import * as Sentry from "@sentry/react";
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { openPopup } from '../../stateManagement/actions/popupActions';
import "./FilterLabel.css"
import { deepClone } from '@mui/x-data-grid/utils/utils';
import { ChannelkartNetworkGet } from '../../services/networkService';
import ConfigComparePopup from '../../components/popup/ConfigComparePopup';
import ImportConfig from '../../components/importConfig/ImportConfig';


export const defaultFilterLabelConfig: filterLabelType = {
    pieceSizeLabelMapping: {
        "name": "pieceSizeLabelMapping",
        "type": "object",
        "value": {},
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "custom disclaimers in order summary page",
        "possibleVals": [
            "string[]"
        ]
    }
}

interface KeyValueTileProps {
    label: string,
    values: filterLabelType,
    setValues: React.Dispatch<React.SetStateAction<filterLabelType>>
}

export function KeyValueTile(props: KeyValueTileProps) {
    const { label, values, setValues } = props;

    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = { ...values };
        val.pieceSizeLabelMapping.value[label] = e.target.value;
        setValues(val);
    }

    return (
        <div className='key_value_tile'>
            <div>{label}</div>
            <div>:</div>
            <div className="answwer_container">
                <Input name={label} value={values.pieceSizeLabelMapping.value?.[label]} onChange={handleValueChange} />
            </div>
        </div>
    )
}



const FilterLabel = () => {
    const [labelConfig, setLabelConfig] = useState<configurationAttributeType[]>([]);
    const [values, setValues] = useState<filterLabelType>(deepClone(defaultFilterLabelConfig))
    const [appValidationsSchema, setAppValidationSchema] = useState({})
    const [pieceLabelFromApi, setPieceLabelFromApi] = useState<{ [key: string]: string }>({})


    const getLabelConfiguration = async () => {
        try {
            const resp = await getNewConfiguration('filters_label_configuration');
            const pieceSizeResp = await ChannelkartNetworkGet("/v1/distinctFieldData/productDetails/pieceSize?size=1000")
            const pieceSizeData = pieceSizeResp.data;
            const pieceSizeObject: { [key: string]: string } = {};
            pieceSizeData.forEach((piece: { [pieceSize: string]: string }) => {
                pieceSizeObject[piece.pieceSize] = "";
            });
            const label_config: configurationAttributeType[] = resp?.domainValues;
            setPieceLabelFromApi({ ...pieceSizeObject })
            setLabelConfig([...label_config])
        } catch (err) {
            // Sentry.captureException(err);
        }
    }
    useEffect(() => {
        getLabelConfiguration();
    }, [])

    const saveConfiguration = async (preview?: boolean) => {

            try {
                const resultantValues = deepClone({...values});
                const appSchema = yup.object({ ...appValidationsSchema })
                const validationObject: any = {};
                Object.keys(resultantValues.pieceSizeLabelMapping.value).map((key)=>{
                    if(resultantValues.pieceSizeLabelMapping.value[key]==''){
                        delete resultantValues.pieceSizeLabelMapping.value[key];
                    } 
                })
                Object.keys(resultantValues).forEach(key => {
                    validationObject[key] = resultantValues[key].value;
                })
                // await appSchema.validate(validationObject)
                const convertedVals = convertValuesToConfig(resultantValues, labelConfig);
                await doFinalConfigSubmit("filters_label_configuration",convertedVals);
            } catch (err) {
                // Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup('Error', "Validation Error occured : " + err?.message)
            }

    }


    const setLabelConfigValues = () => {
        try {
            // if (labelConfig.length) {
                const result = { ...values }
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                labelConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr;
                })
                // const combinedObject = { ...pieceLabelFromApi };
                // const configObject = { ...result.pieceSizeLabelMapping.value }
                // for (const key in configObject) {
                //     if (configObject.hasOwnProperty(key)) {
                //         combinedObject[key] = configObject[key];
                //     }
                // }
                result.pieceSizeLabelMapping.value = {...pieceLabelFromApi,...result.pieceSizeLabelMapping.value};
                setValues({ ...result } as filterLabelType);
                setAppValidationSchema({ ...resValidations })
            // }
        } catch (err) {
            // Sentry.captureException(err);

        }
    }

    useEffect(() => {
        setLabelConfigValues();
    }, [labelConfig])

    const importConfiguration = async (importedConfig:any)=>{
        const newConfigs = await overWriteConfig(importedConfig, {
            filters_label_configuration:"importAll"
        })
        for(const configObject of newConfigs){
            await doFinalConfigSubmit(configObject.domainType, configObject.domainValues)
        }
        getLabelConfiguration();
    }
    const [importConfigState,setImportConfigState] = useState(false);

    return (
        <div className='app_configuration_container'>
            <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={['filters_label_configuration']} importConfigCallback={importConfiguration} />
            <ConfigurationHeader heading={"Filter Label Configuration"} importConfiguration={()=>{setImportConfigState(true)}} saveConfiguration={() => saveConfiguration(false)} showConfirmPopup={true} />
            <div className="config_form_container">
                <div className="form_header">
                    <BorderHeading>Pack size label</BorderHeading>
                </div>
                {
                    Object.keys(values.pieceSizeLabelMapping.value)?.map((key, index) => {
                        return <KeyValueTile label={key} values={values} setValues={setValues} />
                    })
                }



            </div>
        </div>
    )
}

export default FilterLabel